import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9f35e1ba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "text-center" }
const _hoisted_3 = { class: "other" }
const _hoisted_4 = { class: "icon-group" }
const _hoisted_5 = ["src", "onClick"]
const _hoisted_6 = { class: "sign-up-text" }

import { useI18n } from 'vue-i18n';
  import loginFormVue from './components/login-form.vue';
  import { useRoute } from 'vue-router';
  import { getOAuthProviderByLocale } from '@/utils';

  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  const route = useRoute();

  const { t, locale } = useI18n();

  const oAuthList = getOAuthProviderByLocale(locale.value);


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(loginFormVue),
    _createElementVNode("div", _hoisted_2, [
      (!_unref(route).query.hiddOAuth)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)('Sign in via SNS')), 1),
            _createElementVNode("div", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(oAuthList), (item, index) => {
                return (_openBlock(), _createElementBlock("img", {
                  key: index,
                  src: item.url,
                  alt: "",
                  class: "icon",
                  onClick: ($event: any) => (item.click())
                }, null, 8, _hoisted_5))
              }), 128))
            ])
          ], 64))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("span", null, _toDisplayString(_unref(t)('Don\'t have an account?')) + " ", 1),
        _createVNode(_component_router_link, {
          to: {name: 'signup'},
          style: {"font-weight":"bold"}
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('Sign Up')) + ". ", 1)
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})